module.exports = __webpack_public_path__ + "img/5-2.9fb78a7a.jpg";